export const rolePermissions = [
  {
    name: "Dashboard",
    key: "Dashboard",
    url: "Dashboard",
  },
  // {
  //   name: "Location",
  //   key: "Location",
  //   url: "location",
  // },
  {
    name: "Clock In/Out Screen",
    key: "Clock",
    url: "Clock",
  },
  {
    name: "Attendance",
    key: "Attendance",
    url: "Attendance",
  },

  {
    name: "Monthly Target",
    key: "budget",
    url: "budget",
  },

  {
    name: "Daily Target",
    key: "dailyBudget",
    url: "budget",
  },
  {
    name: "Daily Report",
    key: "dailyreport",
    url: "dailyreport",
  },
  {
    name: "Performance",
    key: "performance",
    url: "performance",
  },

  {
    name: "Shift List",
    key: "Shift",
    url: "Shift",
  },

  {
    name: "Calendar View",
    key: "Calendar",
    url: "Calendar",
  },

  {
    name: "Store Management",
    key: "store",
    url: "store",
  },
  {
    name: "Manager Management",
    key: "Manager",
    url: "manager",
  },
  {
    name: "Staff Management",
    key: "Staff",
    url: "staff",
  },
  {
    name: "Business Partners",
    key: "BusinessPartner",
    url: "BusinessPartner",
  },
  {
    name: "Chat",
    key: "chats",
    url: "chats",
  },
  {
    name: "Bulletin Board",
    key: "Bulletin",
    url: "Bulletin",
  },
  // {
  //   name: "Supplier Management",
  //   key: "supplier",
  //   url: "supplier",
  // },
];

export const rolePermission = [
  { name: "Read", key: "read" },
  { name: "Add", key: "add" },
  { name: "Edit", key: "edit" },
  { name: "Delete", key: "delete" },
];

export const roleGetAllKeys = () => {
  let keys = {};
  rolePermissions.map((itm) => {
    rolePermission.map((pitm) => {
      keys = { ...keys, [`${pitm.key}${itm.key}`]: false };
    });
  });

  return keys;
};

export const userType = {
  id: "",
  fullName: "",
  role: "",
  email: "",
  mobileNo: "",
  aboutUs: "",
  address: "",
  image: "",
  logo: "",
};
export const CategoryType = {
  id: "",
  name: "",
  catType: "",
  subParentCategory: "",
  description: "",
  image: "",
  order: "",
  parentCategory: "",
  status: "active",
  icon: "",
  banner: "",
  altImageName: "",
  altIconName: "",
  bannerOverlayHeading: "",
  bannerOverlayBody: "",
  description: "",
  featured: "No",
  urlKey: "",
  metaTitle: "",
  metaDescription: "",
  keywords: "",
};
export const roleType = {
  id: "",
  status: "active",
  permissions: roleGetAllKeys(),
};
export const resellerCategoryType = {
  id: "",
  name: "",
  catType: "Reseller",
  description: "",
  image: "",
};
export const planType = {
  id: "",
  name: "",
  price: "",
  status: "active",
  interval: "Monthly",
  category: "",
  recommended: "",
  allowedProducts: "",
  feature: [],
  monthlyPrice: "",
  threeMonthPrice: "",
  sixMonthPrice: "",
  yearlyPrice: "",
  extraProductPrice: "",
};
export const continentType = { id: "", name: "", status: "active" };
export const featureType = {
  id: "",
  name: "",
  description: "",
  status: "active",
};
export const emailType = { id: "", subject: "", content: "", status: "active" };
export const cityType = {
  id: "",
  name: "",
  status: "active",
  countryId: "",
  regionId: "",
  continent: "",
};
export const bookingSystemType = {
  id: "",
  name: "",
  apiKey: "",
  secretKey: "",
};
export const holidaysType = {
  id: "",
  discOrPre: "",
  name: "",
  type: "",
  country: "",
  counties: "",
  amountOrPercent: "",
  number: "",
  applyFor: [],
  preOrPost: "",
  preDays: "",
  postDays: "",
  changesApply: "",
  changesDate: "",
  changesDateTo: "",
};
export const earlybirdpricingType = {
  id: "",
  name: "",
  discOrPre: "",
  startDate: "",
  country: "",
  counties: "",
  applyEarlyBirdPricing: [],
  endDate: "",
  inventory: [],
  lastMinutePricingFromDate: "",
  lastMinutePricingToDate: "",
  applyPriceType: "",
  changesDate: "",
  changesDateTo: "",
  notApply: "",
  notApplyCondition: "",
  notApplicableFor: [],
  blackOutDates: [],
  amountOrPercent: "",
  number: "",
  applyToDaysTimeSlot: "",
  daysToApply: [],
  timeSlots: [],
};
export const posType = { id: "", name: "", apiKey: "", url: "" };

export const resellerType = {
  id: "",
  name: "",
  logo: "",
  category: "",
  contractDate: "",
  booking: "",
  country: "",
  contactPerson: "",
  contactPhone: "",
  contactEmail: "",
  website: "",
};
export const couponType = {
  id: "",
  title: "",
  status: "active",
  description: "",
  couponCode: "",
  usesPerCoupon: "",
  usesPerCustomer: "",
  dateFrom: "",
  dateTo: "",
  discountType: "",
  discountAmount: "",
};
